import { render, staticRenderFns } from "./FooterComponentRhh.vue?vue&type=template&id=6609030a&scoped=true"
import script from "./FooterComponentRhh.vue?vue&type=script&lang=ts"
export * from "./FooterComponentRhh.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentRhh.vue?vue&type=style&index=0&id=6609030a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6609030a",
  null
  
)

export default component.exports